(() => {
  if (window.FourPawProductCardSwatches) return;

  const activate = (button) => {
    const card = button.closest('[data-fp-product-card]');
    const image = card?.querySelector('.fp-product-card__media img');
    if (!card) return;

    if (image && button.dataset.imageSrc) {
      image.src = button.dataset.imageSrc;
      if (button.dataset.imageSrcset) image.srcset = button.dataset.imageSrcset;
      if (button.dataset.imageAlt) image.alt = button.dataset.imageAlt;
    }

    const currentPrice = card.querySelector('.fp-price__current');
    const comparePrice = card.querySelector('.fp-price__compare');
    if (currentPrice && button.dataset.variantPrice) currentPrice.textContent = button.dataset.variantPrice;
    if (comparePrice) {
      comparePrice.textContent = button.dataset.variantComparePrice || '';
      comparePrice.hidden = !button.dataset.variantComparePrice;
    }

    const variantUrl = button.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('[data-fp-card-link]').forEach((link) => {
        link.href = variantUrl;
      });
    }

    card.querySelectorAll('[data-fp-card-swatch]').forEach((swatch) => {
      const selected = swatch === button;
      swatch.classList.toggle('is-selected', selected);
      swatch.setAttribute('aria-pressed', String(selected));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-fp-card-swatch]');
    if (button) activate(button);
  });
  document.addEventListener('shopify:section:load', () => {});
  document.addEventListener('shopify:section:unload', () => {});
  document.addEventListener('shopify:block:select', (event) => {
    const selected = event.target.querySelector?.('[data-fp-card-swatch].is-selected');
    if (selected) activate(selected);
  });

  window.FourPawProductCardSwatches = { activate };
})();
